import { render, staticRenderFns } from "./Dendrogram.pug?vue&type=template&id=1d38b303&lang=pug&external"
import script from "./Dendrogram.js?vue&type=script&lang=js&external"
export * from "./Dendrogram.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports